import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeroLayout from "../components/HeroLayout";
const images = require.context("../assets/images", false);

function Blog() {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPosts(page);
  }, []);

  const fetchPosts = async (pageNumber) => {
    try {
      setLoading(true);

      const res = await fetch(
        `https://luxurygoldentriangle.com/bkadmn/wp-json/wp/v2/posts?per_page=12&page=${pageNumber}&_embed`
      );

      // If no more posts
      if (res.status === 400) {
        setHasMore(false);
        setLoading(false);
        return;
      }

      const data = await res.json();

      if (data.length === 0) {
        setHasMore(false);
      } else {
        setPosts((prevPosts) => [...prevPosts, ...data]);
      }

      setLoading(false);

    } catch (error) {
      console.error("Error fetching posts:", error);
      setLoading(false);
    }
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchPosts(nextPage);
  };

  return (
    <>
    <HeroLayout>
      <div className="banner-bg" style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./blog.webp")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>THE Golden Triangle Tour Experts</h1>
            </div>
        </div>
        </div>

    </HeroLayout>
    <div className="blog paddingY-70">
      <div className="container">
        <div className="row">

          {posts.map((post) => {
            const featuredImage =
              post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url;

            const author =
              post?._embedded?.author?.[0]?.name;

            return (
              <div className="col-md-6 col-lg-4" key={post.id}>
                <div className="blog-card">

                  <Link to={`/${post.slug}`}>
                    <img
                      src={featuredImage}
                      alt={post.title.rendered}
                    />
                  </Link>

                  <div className="author-detail">
                    <p>
                     <img src={images("./calender.svg")} /> {new Date(post.date).toLocaleDateString()}
                    </p>
                  </div>

                  <div className="blog-text">
                    <span>{author}</span>

                    <h3>
                      <Link to={`/${post.slug}`}>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: post.title.rendered,
                          }}
                        />
                      </Link>
                    </h3>

                  <div
  className="font-14"
  dangerouslySetInnerHTML={{
    __html: post.excerpt.rendered,
  }}
/>
                  </div>

                  <div className="blog-card-author">
                    <img src={images("./profile.png")} />
                    <div className="blog-card-author-info">
                        <p>
                        <b>{author}</b>
                        </p>
                        <p>Admin</p>
                    </div>
                    </div>
    


                </div>
              </div>
            );
          })}

          {hasMore && (
            <div className="col-md-12">
              <div className="blog-btn center mt-5">
                <button
                  className="primary-btn"
                  onClick={handleLoadMore}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "+ Load More"}
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
    </>
  );
}

export default Blog;